(() => {
  'use strict';
  const tabs = document.querySelector('[data-routine-tabs]');
  if (tabs) {
    const buttons = [...tabs.querySelectorAll('[role="tab"]')];
    function activate(button, focus = false) {
      buttons.forEach(b => {
        const selected = b === button;
        b.setAttribute('aria-selected', String(selected));
        b.tabIndex = selected ? 0 : -1;
        document.getElementById(b.getAttribute('aria-controls')).hidden = !selected;
      });
      if (focus) button.focus();
    }
    tabs.hidden = false; activate(buttons[0]);
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        activate(buttons[next], true);
      });
    });
  }
  const timer = document.querySelector('[data-brush-timer]');
  if (!timer) return;
  const toggle = timer.querySelector('[data-timer-toggle]');
  const readout = timer.querySelector('[data-timer-readout]');
  const status = timer.querySelector('[data-timer-status]');
  const progress = timer.querySelector('.se-timer-progress');
  let remaining = 120000, deadline = 0, interval = null;
  timer.querySelector('[data-timer-actions]').hidden = false;
  function render() {
    const seconds = Math.ceil(remaining / 1000);
    readout.textContent = Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
    progress.style.strokeDashoffset = String(100 * (1 - remaining / 120000));
  }
  function stop() { clearInterval(interval); interval = null; }
  function tick() {
    remaining = Math.max(0, deadline - Date.now()); render();
    if (remaining === 0) { stop(); toggle.textContent = 'Start again'; status.textContent = 'Two minutes complete. Your brushing time is up.'; }
  }
  toggle.addEventListener('click', () => {
    if (interval !== null) {
      remaining = Math.max(0, deadline - Date.now()); stop(); render();
      toggle.textContent = remaining > 0 ? 'Resume brushing' : 'Start again'; status.textContent = 'Timer paused.';
    } else {
      if (remaining <= 0) remaining = 120000;
      deadline = Date.now() + remaining; toggle.textContent = 'Pause timer'; status.textContent = 'Brushing timer running.';
      interval = setInterval(tick, 200); tick();
    }
  });
  timer.querySelector('[data-timer-reset]').addEventListener('click', () => {
    stop(); remaining = 120000; render(); toggle.textContent = 'Start brushing'; status.textContent = 'Timer reset. Ready for two minutes.';
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && interval !== null) tick(); });
  window.addEventListener('pagehide', stop);
})();
